import { AxiosInstance } from 'axios';
import { OrderBulkFinanceService } from './OrderBulkFinanceService';

export class OrderBulkService {
  instance: AxiosInstance;
  finance: OrderBulkFinanceService;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.finance = new OrderBulkFinanceService(instance);
  }
}
